import Ajv from 'ajv';
import addFormats from 'ajv-formats';
import betterAjvErrors from 'better-ajv-errors';
import { ProjectConfig } from '../../types';
import addCustomKeywords from './addCustomKeywords';
import getFullSchema from './schema/full';

export default function validateConfig({
  config,
  projectRoot,
}: {
  config: ProjectConfig;
  projectRoot: string;
}) {
  const context = { projectRoot };
  const schema = getFullSchema(context);

  const ajv = new Ajv({ allErrors: true });
  addFormats(ajv);
  addCustomKeywords(ajv, context);
  const validate = ajv.compile(schema);

  if (config.productName) {
    throw new Error(
      `todesktop.json invalid.

The "productName" property is no longer supported in todesktop.json. Please remove it and add it to your app's package.json instead.

We made this change because Electron also uses the "productName" if it exists in your app's package.json. If you do not add it to your package.json, your app name will default to the value of the "name" property in your package.json.`,
    );
  }

  if (!validate(config)) {
    const output = betterAjvErrors(schema, config, validate.errors ?? [], {
      indent: 2,
    });

    throw new Error(
      `todesktop.json invalid. \nLearn more here: https://www.npmjs.com/package/@todesktop/cli#project-configuration-todesktopjson \n\n${output}`,
    );
  }
}
